var map = {
	"./en/home_logo.png": 4008,
	"./ja/home_logo.png": 1168,
	"./parts/button_back.png": 2836,
	"./parts/button_bookmark_off.png": 1704,
	"./parts/button_bookmark_on.png": 7728,
	"./parts/button_delete.png": 5856,
	"./parts/button_search_delete.png": 1628,
	"./parts/button_sound.png": 388,
	"./parts/check_off.png": 9284,
	"./parts/check_on.png": 1540,
	"./parts/icon_arrow.png": 5808,
	"./parts/icon_bookmark_large.png": 8940,
	"./parts/icon_bookmark_off.png": 2096,
	"./parts/icon_bookmark_on.png": 9320,
	"./parts/icon_bookmark_text_on.png": 2580,
	"./parts/icon_dictionary_off.png": 4044,
	"./parts/icon_dictionary_on.png": 5592,
	"./parts/icon_error_large.png": 6312,
	"./parts/icon_history_large.png": 9520,
	"./parts/icon_history_off.png": 6872,
	"./parts/icon_history_on.png": 3200,
	"./parts/icon_search_large.png": 6104,
	"./parts/icon_search_small.png": 2624,
	"./parts/loading.gif": 8400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8433;